
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
Vue.component('claimlisting', require('./components/ClaimListing.vue'));
Vue.use(Vuetify)
const app = new Vue({
    vuetify : new Vuetify(),
    el: '#claimlisting'
});



// WEBPACK FOOTER //
// ./resources/assets/js/listingsearch.js